import script from "./GeoblockRuleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoblockRuleSelector.vue?vue&type=script&setup=true&lang=ts"

import "./GeoblockRuleSelector.vue?vue&type=style&index=0&id=4b217216&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b217216"]])

export default __exports__